import PropTypes from 'prop-types';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
// @mui
import { List, Collapse } from '@mui/material';
//
import { NavItemRoot, NavItemSub } from './NavItem';
import { getActive } from '..';
import { PrivateRoute } from 'src/Auth/components/PrivateRoute';
import LocalStorageService from 'src/shared/services/localStorageService';
// ----------------------------------------------------------------------

NavListRoot.propTypes = {
  isCollapse: PropTypes.bool,
  list: PropTypes.object,
};

export function NavListRoot({ list, isCollapse }) {
  const { pathname } = useLocation();

  // get user roles from local storage (authData.roles expected as array)
  const userRoles = new LocalStorageService().authData?.roles || [];

  const hasRoleAccess = (requiredRoles) => {
    if (!requiredRoles || requiredRoles.length === 0) return true;
    return requiredRoles.some((r) => userRoles.includes(r));
  };

  const active = getActive(list.path, pathname);

  const [open, setOpen] = useState(active);

  const hasChildren = list.children;
  //console.log("navaaa:"+JSON.stringify(list)+"____"+JSON.stringify(hasChildren))
  // if this menu has role restriction and user doesn't have required role, hide it
  console.log("navaaa:"+JSON.stringify(list)+"____"+JSON.stringify(hasChildren),list.roles,userRoles)
  if (!hasRoleAccess(list.roles)) return null;

  if (hasChildren) {
    return (
      <>
        <PrivateRoute menuid={list.menuid} routeType={1}>
          <NavItemRoot
            item={list}
            isCollapse={isCollapse}
            active={active}
            open={open}
            onOpen={() => setOpen(!open)}
          />

          {!isCollapse && (
            <Collapse in={open} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {(list.children || []).map((item) => {
                  // if child has role restriction and user doesn't have it, skip
                  if (item.roles && !hasRoleAccess(item.roles)) return null;
                  return (
                    <PrivateRoute key={item.title} menuid={item.menuid} routeType={1}>
                      <NavListSub list={item} />
                    </PrivateRoute>
                  );
                })}
              </List>
            </Collapse>
          )}
        </PrivateRoute>
      </>
    );
  }

  // leaf item - check roles too
  if (!hasRoleAccess(list.roles)) return null;
  return <NavItemRoot item={list} active={active} isCollapse={isCollapse} />;
}

// ----------------------------------------------------------------------

NavListSub.propTypes = {
  list: PropTypes.object,
};

function NavListSub({ list }) {
  const { pathname } = useLocation();

  const userRoles = new LocalStorageService().authData?.roles || [];

  const hasRoleAccess = (requiredRoles) => {
    if (!requiredRoles || requiredRoles.length === 0) return true;
    return requiredRoles.some((r) => userRoles.includes(r));
  };

  const active = getActive(list.path, pathname);

  const [open, setOpen] = useState(active);

  const hasChildren = list.children;

  // if this sub-item has role restriction and user doesn't have it, hide it
  if (!hasRoleAccess(list.roles)) return null;

  if (hasChildren) {
    return (
      <>
        <NavItemSub item={list} onOpen={() => setOpen(!open)} open={open} active={active} />

        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding sx={{ pl: 3 }}>
            {(list.children || []).map((item) => {
              if (item.roles && !hasRoleAccess(item.roles)) return null;
              return <NavItemSub key={item.title} item={item} active={getActive(item.path, pathname)} />;
            })}
          </List>
        </Collapse>
      </>
    );
  }

  // leaf sub-item
  if (!hasRoleAccess(list.roles)) return null;
  return <NavItemSub item={list} active={active} />;
}
